module.exports = __webpack_public_path__ + "03858c243fe609105873d70f1d9ab61f.svg";